module.exports = __webpack_public_path__ + "img/dhaanvi.1216be89.jpeg";